import { cva } from '@mentimeter/ragnar-tailwind-config';

export const variants = cva(
  [
    'z-1',
    'align-center',
    'justify-center',
    'flex-auto',
    'transition-all',
    'ease-in-out',
    'duration-[0.1s]',
    'group-data-[has-state="false"]:group-hover:scale-110',
    'group-data-[has-state="false"]:group-active:scale-100',
    '[&_svg]:w-full',
    '[&_svg]:h-full',
  ],
  {
    variants: {
      size: {
        large: ['w-[theme(fontSize.150)]', 'h-[theme(fontSize.150)]'],
        default: ['w-[theme(fontSize.100)]', 'h-[theme(fontSize.100)]'],
        compact: ['w-[theme(fontSize.100)]', 'h-[theme(fontSize.100)]'],
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);
